export const AcceptedResponseType = {
  Json: 'json',
  None: 'none'
};